<template>
  <div>
    <ckeditor
      :config="editorConfig"
      :editor="editor"
      :name="name"
      :value="value"
      @input="onInput"
      @ready="onEditorReady"
      ref="editor"
    />
    <div class="row justify-content-between">
      <div class="col-md-6 text-left">
        <div
          v-if="danger"
          class="con-text-validation span-text-validation-danger v-enter-to"
        >
          <span class="span-text-validation">
            {{ dangerText }}
          </span>
        </div>
      </div>
      <div class="col-md-6 text-right" v-if="withCounter">
        <small
          v-tooltip="'Contador de caracteres'"
          :class="{ 'text-danger font-weight-bold': lengthText > maxLength }"
        >
          {{ lengthText }}/{{ maxLength }}
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import viewToPlainText from '@ckeditor/ckeditor5-clipboard/src/utils/viewtoplaintext';

import Editor from 'ckeditor5-custom-build/build/ckeditor';

import '@ckeditor/ckeditor5-build-classic/build/translations/es';

export default {
  name: 'EditorText',
  data() {
    return {
      editor: Editor,
      editorConfig: {
        image: {
          resizeUnit: 'px',
          resizeOptions: [
            {
              name: 'resizeImage:original',
              label: 'Original',
              value: null
            },
            {
              name: 'resizeImage:100',
              label: '100px',
              value: '100'
            },
            {
              name: 'resizeImage:200',
              label: '200px',
              value: '200'
            }
          ]
        },
        autoDimensions: true,
        language: 'es',
        toolbar: {
          items: [
            'undo', 'redo',
            '|', 'heading',
            '|', 'bold', 'italic',
            '|', 'numberedList', 'bulletedList'
          ]
        }
      },
      dataEditor: {}
    };
  },
  computed: {
    // eslint-disable-next-line consistent-return,vue/return-in-computed-property
    lengthText() {
      if (this.dataEditor.editing) {
        return this.getTextPlain().length;
      }
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event);
    },
    onEditorReady(editor) {
      this.dataEditor = editor || {};
    },
    // eslint-disable-next-line consistent-return
    getTextPlain() {
      if (this.dataEditor.editing) {
        return viewToPlainText(this.dataEditor?.editing?.view?.document?.getRoot());
      }
    }
  },
  props: {
    danger: { type: Boolean },
    dangerText: { type: String },
    name: { type: String, required: true },
    value: { type: String },
    maxLength: { type: Number },
    withCounter: { type: Boolean, default: false }
  }
};
</script>

<style>
.ck-editor__editable_inline {
  padding: 0 25px !important;
}
.ck-content {
  min-height: 200px;
  max-height: 400px;
}

#snippet-image-resize-buttons + .ck .ck-content h2 {
  border-bottom: 4px solid black;
  font-weight: 800;
  text-transform: uppercase;
}

#snippet-image-resize-buttons + .ck .ck-content hr {
  background-color: black;
}

#snippet-image-resize-buttons + .ck .ck-content .ck-horizontal-line {
  margin-top: -12px;
}
.ck-content .image-style-side {
  max-width: 50%;
  float: right;
  margin-left: var(--ck-image-style-spacing);
}
.ck-content .image.image_resized {
  max-width: 100%;
}
.ck-content .image.image_resized {
  display: block;
  box-sizing: border-box;
}

</style>
